const validate = values => {
  const errors = {}
  if (!values.title) {
    errors.title = "The title is required!"
  }
  if (values.button_url && !values.button_text) {
    errors.button_text = "The button text is required!"
  }

  if (!values.visibility_limit) {
    errors.visibility_limit = "The limit is required!"
  }

  if (values.visibility_limit && values?.visibility_limit < 0) {
    errors.visibility_limit = "The minimum value is 0!"
  }

  if (
    values.button_url &&
    !/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(
      values.button_url
    )
  ) {
    errors.button_url =
      "The URL is invalid! It must include both http:// or https:// and a suffix like .com"
  }
  return errors
}

export default validate
